module.exports = "/_next/static/images/teaches-logo-b8b16be394d08ea7390d2f684ae50a3f.png";